import { Pagination, Rate } from "antd";
import React, { useState } from "react";
import { PRIMARY_THEME } from "../../constants/constant";

const UserProductReview = ({ reviews = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;

  const paginatedReviews = reviews?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const ReviewCard = ({ reviewData }) => {
    const { review, user } = reviewData;
    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "16px",
          backgroundColor: "#fff",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Rate
            disabled
            value={review.rating}
            style={{ fontSize: "18px", color: PRIMARY_THEME }}
          />
          <span style={{ fontSize: "12px", color: "#888" }}>
            {new Date(review.created_at).toLocaleDateString()}
          </span>
        </div>
        <div style={{ marginTop: "8px", fontWeight: "bold", fontSize: "16px" }}>
          {user.name}
        </div>
        <p style={{ marginTop: "8px", color: "#555", fontSize: "14px" }}>
          {review.content}
        </p>
      </div>
    );
  };
  return (
    <div className="py-3">
      <div className="pb-2" style={{ fontSize: "20px" }}>
        Product Reviews
      </div>
      <div>
        {paginatedReviews.length > 0 ? (
          <>
            {paginatedReviews.map((reviewData) => (
              <ReviewCard key={reviewData.review.id} reviewData={reviewData} />
            ))}
            {reviews?.length > pageSize && (
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={reviews?.length}
                onChange={(page) => setCurrentPage(page)}
                simple={{
                  readOnly: true,
                }}
                align="center"
              />
            )}
          </>
        ) : (
          <div className="text-center">
            <p className="details-key">
              No reviews available for this product.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProductReview;
